import { FC } from 'react';

import { Stack } from 'libs/ui';
import { SvgProps } from 'libs/ui/Icon/icons/types';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

const ContentStyled = styled(Stack)({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  width: 44,
});

export const renderIcon = (Icon: FC<SvgProps>) => (
  <ContentStyled>
    <Icon color={Colors.gray500} size={16} />
  </ContentStyled>
);
